const Strings = {
  SELECT_HOUSE: 'Välj hus'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/SelectCommunityDialog/strings.js